<main class="bg-white position-relative">
  <div class="container padd-top top-title-bar">
    <div class="row align-items-center">
      <div class="col-lg-6 col-md-5 category-title-top">
        <h4><a routerLink="">Home/</a> Category</h4>
      </div>
      <div class="col-lg-6 col-md-7">
        <div class="popularity-right-sec popularity-right-sort">
          <h4><b>Share:</b></h4>
          <ul>
            <li>
              <a href="#" target="_blank"><i aria-hidden="true" class="fa fa-facebook"></i></a>
            </li>
            <li>
              <a href="#" target="_blank"><i aria-hidden="true" class="fa fa-twitter"></i></a>
            </li>
            <li>
              <a href="#" target="_blank"><i aria-hidden="true" class="fa fa-google-plus"></i></a>
            </li>
            <li>
              <a href="#" target="_blank"><i aria-hidden="true" class="fa fa-youtube-play"></i></a>
            </li>
            <li>
              <a href="#" target="_blank"><i aria-hidden="true" class="fa fa-instagram"></i></a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <section class="signup-step-container padd-top-bot signup-step-categories">
    <div class="container">
      <div class="row d-flex justify-content-center">
        <div class="col-12">
          <div class="wizard">
            <form class="login-box">
              <div class="tab-content" id="main_form">
                <div class="tab-pane active" id="step1" role="tabpanel">
                  <div class="col-12">
                    <div class="row">
                      <div class="col-md-6 product-left">
                        <div id="slick-product">
                          <div class="column small-11 small-centered row">
                            <div class="slider slider-nav">
                              <div class="product-slider-img">
                                <img alt=""
                                     class="img-fluid" src=".//assets/images/product-img1.png"/>
                              </div>
                              <div class="product-slider-img"><img
                                alt=""
                                class="img-fluid" src=".//assets/images/product-img2.png"/></div>
                              <div class="product-slider-img"><img
                                alt=""
                                class="img-fluid" src=".//assets/images/product-img3.png"/></div>
                              <div class="product-slider-img product-slider-img-sec">
                                <img alt=""
                                     class="img-fluid" src=".//assets/images/product-img4.png"/></div>
                            </div>
                            <div class="slider slider-single">
                              <div class="buy-new-product">
                                <img alt=""
                                     class="img-fluid" src=".//assets/images/product-img1.png"/>
                              </div>
                              <div class="buy-new-product"><img
                                alt=""
                                class="img-fluid" src=".//assets/images/product-img2.png"/></div>
                              <div class="buy-new-product"><img
                                alt=""
                                class="img-fluid" src=".//assets/images/product-img3.png"/></div>
                              <div class="buy-new-product"><img
                                alt=""
                                class="img-fluid" src=".//assets/images/product-img4.png"/></div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6 product-right">
                        <div class="buy-now-top-sec">
                          <div class="inner-buy-now inner-buy-now1">
                            <p>Buy or Bid</p>
                            <span><b>$215 </b> lowest ask</span>
                          </div>
                          <div class="inner-buy-now inner-buy-now2">
                            <p>Sell or Ask</p>
                            <span><b>$305 </b> highest BId</span>
                          </div>
                          <div class="inner-buy-now inner-buy-now3">
                            <p>Last Sale</p>
                            <div class="last-sale-price">
                              <h3>$273.00</h3>
                              <a href="#"><i aria-hidden="true"
                                             class="fa fa-arrow-down"></i> -$1 (0%)</a>
                            </div>
                          </div>
                        </div>
                        <h2 class="sec-heading">Off-White x Air Force 1 Low-Volt</h2>
                        <ul class="condition-sec">
                          <li>Condition: <span>New</span></li>
                          <li>SKU: <span>AJ1H-CP</span></li>
                          <li><span>100% Authentic</span></li>
                        </ul>
                        <div class="product-prize-sec-top">
                          <h2>$65.00<span>$70.00</span></h2>
                          <div class="select_filed size-selected">
                            <select aria-invalid="false" class="wpcf7-form-control wpcf7-select"
                                    class="Wide"
                                    name="Selectbox">
                              <option value="AQI India">Size</option>
                              <option value="Second One">1</option>
                              <option value="Third one">2</option>
                            </select>
                          </div>
                        </div>
                        <div class="border-line"></div>
                        <div class="row release-date">
                          <div class="col-md-8 col-md-7">
                            <p>Release Date: <b>May 19, 2020</b></p>
                            <p>Colorway: <b>Black/White - Cone - Black</b></p>
                          </div>
                          <div class="col-md-4 col-md-4">
                            <p>SKU: <b>AO4606-700</b></p>
                            <p>Retail Price:<b> $65.00</b></p>
                          </div>
                        </div>
                        <div class="date-picker-sec-top">
                          <div class="inner-date-picker">
                            <img alt="" src=".//assets/images/date-picker-icon.png"/>
                            <p>Date</p>
                          </div>
                          <input class="form-control position-absolute" id="example-date-input"
                                 type="date" value=""/>
                        </div>
                        <div
                          class="top_sell_opetion d-flex align-items-center justify-content-between mt-4">
                          <a
                            class="top_sell_a_tag top_sell_a_tag_1 text-center d-inline-block text-dark border text-uppercase font_16 px-lg-4 py-lg-2 px-xl-5 py-xl-2 bold_700"
                            href="javascript:void(0);">Bid</a>
                          <a
                            class="top_sell_a_tag top_sell_a_tag_2 text-center d-inline-block text-white bg-dark border text-uppercase font_16 px-lg-4 py-lg-2 px-xl-5 py-xl-2 bold_700"
                            href="javascript:void(0);">
                            Buy Now
                          </a>
                          <a
                            class="top_sell_a_tag top_sell_a_tag_3 text-center d-inline-block text-dark border text-uppercase font_16 px-lg-4 py-lg-2 px-xl-5 py-xl-2 bold_700"
                            href="javascript:void(0);">Sell</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="position-relative overflow-hidden" id="new_releases_sec">
    <div class="new new_releases_container">
      <div class="container product-slider-sec">
        <div class="pt-md-5 border-top padd-top-bot mb-3">
          <div class="row align-items-center">
            <div class="col-md-7 col-7">
              <div class="main_def_title">
                <h2 class="text-uppercase text-dark oswald_font font_30 bold_600">Recommanded for
                  you</h2>
              </div>
            </div>
            <div class="col-md-5 col-5">
              <div class="right_smll_text text-right">
                <h6>
                  <a class="open_sans bold_700 text-green text-right font_16 see-all-btn"
                     routerLink="/categories-detail">See All
                    <i aria-hidden="true" class="fa fa-angle-right font_20"></i></a>
                </h6>
              </div>
            </div>
          </div>
          <div class="new_releases_slider_main mt-4 pt-2">
            <div
              class="top_selling_slider new_releases_slider owl-carousel owl-theme owl-loaded owl-drag">
              <div class="owl-stage-outer">
                <div class="owl-stage">
                  <div class="owl-item active">
                    <div class="item">
                      <div class="top_selling_product_box">
                        <div
                          class="top_sell_img border bg-white position-relative overflow-hidden">
                          <div
                            class="label_sell position-absolute bg-light px-sm-3 px-lg-3 px-xl-4 py-sm-2">
                                                            <span
                                                              class="text-uppercase open_sans bold_700 font_20">April
                                                                18</span>
                          </div>
                          <div class="add-top-cart-btn">
                            <a href="#"><i aria-hidden="true"
                                           class="fa fa-shopping-cart"></i> Add To Cart</a>
                          </div>
                          <a class="d-inline-block w-100 h-100 image_hover position-relative"
                             href="javascript:void(0);"><img
                            alt="" class="img-fluid"
                            src="/assets/images/new_releases_product_1.png"/></a>
                        </div>
                        <div class="top_sell_title text-center mt-3">
                          <h3><a class="open_sans bold_400 font_20"
                                 href="javascript:void(0);">Jordan 6 Retro DMP
                            (2020)</a></h3>
                          <h4 class="mt-2 oswald_font bold_600 font_20 text-dark">$230.00
                          </h4>
                        </div>
                        <div class="cart-btn-mobile ">
                          <a href="#"><i aria-hidden="true"
                                         class="fa fa-shopping-cart"></i> Add To Cart</a>
                        </div>
                        <div
                          class="top_sell_opetion d-flex align-items-center justify-content-between mt-4">
                          <a
                            class="top_sell_a_tag top_sell_a_tag_1 text-center d-inline-block text-dark border text-uppercase font_16 px-lg-4 py-lg-2 px-xl-5 py-xl-2 bold_700"
                            href="javascript:void(0);">Bid</a>
                          <a
                            class="top_sell_a_tag top_sell_a_tag_2 text-center d-inline-block text-white bg-dark border text-uppercase font_16 px-lg-4 py-lg-2 px-xl-5 py-xl-2 bold_700"
                            href="javascript:void(0);">
                            Buy Now
                          </a>
                          <a
                            class="top_sell_a_tag top_sell_a_tag_3 text-center d-inline-block text-dark border text-uppercase font_16 px-lg-4 py-lg-2 px-xl-5 py-xl-2 bold_700"
                            href="javascript:void(0);">Sell</a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="owl-item active">
                    <div class="item">
                      <div class="top_selling_product_box">
                        <div class="top_sell_img border bg-white overflow-hidden">
                          <div
                            class="label_sell position-absolute bg-light px-sm-3 px-lg-3 px-xl-4 py-sm-2">
                                                            <span
                                                              class="text-uppercase open_sans bold_700 font_20">April
                                                                17</span>
                          </div>
                          <div class="add-top-cart-btn">
                            <a href="#"><i aria-hidden="true"
                                           class="fa fa-shopping-cart"></i> Add To Cart</a>
                          </div>
                          <a class="d-inline-block w-100 h-100 image_hover position-relative"
                             href="javascript:void(0);"><img
                            alt="" class="img-fluid"
                            src="/assets/images/new_releases_product_2.png"/></a>
                        </div>
                        <div class="top_sell_title text-center mt-3">
                          <h3><a class="open_sans bold_400 font_20"
                                 href="javascript:void(0);">Adidas Yeezy Boost
                            350 V2 Linen</a></h3>
                          <h4 class="mt-2 oswald_font bold_600 font_20 text-dark">$270.00
                          </h4>
                        </div>
                        <div class="cart-btn-mobile ">
                          <a href="#"><i aria-hidden="true"
                                         class="fa fa-shopping-cart"></i> Add To Cart</a>
                        </div>
                        <div
                          class="top_sell_opetion d-flex align-items-center justify-content-between mt-4">
                          <a
                            class="top_sell_a_tag top_sell_a_tag_1 text-center d-inline-block text-dark border text-uppercase font_16 px-lg-4 py-lg-2 px-xl-5 py-xl-2 bold_700"
                            href="javascript:void(0);">Bid</a>
                          <a
                            class="top_sell_a_tag top_sell_a_tag_2 text-center d-inline-block text-white bg-dark border text-uppercase font_16 px-lg-4 py-lg-2 px-xl-5 py-xl-2 bold_700"
                            href="javascript:void(0);">
                            Buy Now
                          </a>
                          <a
                            class="top_sell_a_tag top_sell_a_tag_3 text-center d-inline-block text-dark border text-uppercase font_16 px-lg-4 py-lg-2 px-xl-5 py-xl-2 bold_700"
                            href="javascript:void(0);">Sell</a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="owl-item active">
                    <div class="item">
                      <div class="top_selling_product_box">
                        <div class="top_sell_img border bg-white overflow-hidden">
                          <div
                            class="label_sell position-absolute bg-light px-sm-3 px-lg-3 px-xl-4 py-sm-2">
                                                            <span
                                                              class="text-uppercase open_sans bold_700 font_20">April
                                                                18</span>
                          </div>
                          <div class="add-top-cart-btn">
                            <a href="#"><i aria-hidden="true"
                                           class="fa fa-shopping-cart"></i> Add To Cart</a>
                          </div>
                          <a class="d-inline-block w-100 h-100 image_hover position-relative"
                             href="javascript:void(0);"><img
                            alt="" class="img-fluid"
                            src="/assets/images/new_releases_product_3.png"/></a>
                        </div>
                        <div class="top_sell_title text-center mt-3">
                          <h3><a class="open_sans bold_400 font_20"
                                 href="javascript:void(0);">Jordan 1 Retro High
                            Court Purple White</a></h3>
                          <h4 class="mt-2 oswald_font bold_600 font_20 text-dark">$200.00
                          </h4>
                        </div>
                        <div class="cart-btn-mobile ">
                          <a href="#"><i aria-hidden="true"
                                         class="fa fa-shopping-cart"></i> Add To Cart</a>
                        </div>
                        <div
                          class="top_sell_opetion d-flex align-items-center justify-content-between mt-4">
                          <a
                            class="top_sell_a_tag top_sell_a_tag_1 text-center d-inline-block text-dark border text-uppercase font_16 px-lg-4 py-lg-2 px-xl-5 py-xl-2 bold_700"
                            href="javascript:void(0);">Bid</a>
                          <a
                            class="top_sell_a_tag top_sell_a_tag_2 text-center d-inline-block text-white bg-dark border text-uppercase font_16 px-lg-4 py-lg-2 px-xl-5 py-xl-2 bold_700"
                            href="javascript:void(0);">
                            Buy Now
                          </a>
                          <a
                            class="top_sell_a_tag top_sell_a_tag_3 text-center d-inline-block text-dark border text-uppercase font_16 px-lg-4 py-lg-2 px-xl-5 py-xl-2 bold_700"
                            href="javascript:void(0);">Sell</a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="owl-item">
                    <div class="item">
                      <div class="top_selling_product_box">
                        <div
                          class="top_sell_img border bg-white position-relative overflow-hidden">
                          <div
                            class="label_sell position-absolute bg-light px-sm-3 px-lg-3 px-xl-4 py-sm-2">
                                                            <span
                                                              class="text-uppercase open_sans bold_700 font_20">April
                                                                18</span>
                          </div>
                          <div class="add-top-cart-btn">
                            <a href="#"><i aria-hidden="true"
                                           class="fa fa-shopping-cart"></i> Add To Cart</a>
                          </div>
                          <a class="d-inline-block w-100 h-100 image_hover position-relative"
                             href="javascript:void(0);"><img
                            alt="" class="img-fluid"
                            src="/assets/images/new_releases_product_1.png"/></a>
                        </div>
                        <div class="top_sell_title text-center mt-3">
                          <h3><a class="open_sans bold_400 font_20"
                                 href="javascript:void(0);">Jordan 6 Retro DMP
                            (2020)</a></h3>
                          <h4 class="mt-2 oswald_font bold_600 font_20 text-dark">$230.00
                          </h4>
                        </div>
                        <div class="cart-btn-mobile ">
                          <a href="#"><i aria-hidden="true"
                                         class="fa fa-shopping-cart"></i> Add To Cart</a>
                        </div>
                        <div
                          class="top_sell_opetion d-flex align-items-center justify-content-between mt-4">
                          <a
                            class="top_sell_a_tag top_sell_a_tag_1 text-center d-inline-block text-dark border text-uppercase font_16 px-lg-4 py-lg-2 px-xl-5 py-xl-2 bold_700"
                            href="javascript:void(0);">Bid</a>
                          <a
                            class="top_sell_a_tag top_sell_a_tag_2 text-center d-inline-block text-white bg-dark border text-uppercase font_16 px-lg-4 py-lg-2 px-xl-5 py-xl-2 bold_700"
                            href="javascript:void(0);">
                            Buy Now
                          </a>
                          <a
                            class="top_sell_a_tag top_sell_a_tag_3 text-center d-inline-block text-dark border text-uppercase font_16 px-lg-4 py-lg-2 px-xl-5 py-xl-2 bold_700"
                            href="javascript:void(0);">Sell</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="owl-nav">
                <button class="owl-prev disabled" type="button"><span
                  aria-label="Previous">‹</span></button>
                <button class="owl-next" type="button"><span aria-label="Next">›</span></button>
              </div>
              <div class="owl-dots disabled"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</main>
